import { render, staticRenderFns } from "./AddInventoryBlind.vue?vue&type=template&id=06ec43a2&"
import script from "./AddInventoryBlind.vue?vue&type=script&lang=js&"
export * from "./AddInventoryBlind.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports